export default class {
    constructor(Component) {
        this.Component  = Component;
        this.wrap       = Component.container.querySelector('.box-listing-title');
        this.container  = Component.container.querySelector('.box-listing-title .title');
    }

    isEmpty() {
        return !this.container;
    }

    update() {
        if (this.wrap) {
            let classList = this.wrap.classList;
            this.isEmpty() ? classList.add('only-pagination') : classList.remove('only-pagination');
        }
    }
}
